import { Column } from "components/Table/Table";
import { DATE_FORMAT_PRINT } from "config/constants";
import { requestColorPrinter } from "constants/colors";
import useText from "constants/text";
import { ERequestStatus, ERequestType, Request, RequestDocument } from "generated/graphql";
import styled from "styled-components";

import moment from "moment";
import { Evolution, LinearEvulotionRequest, StatusContainerRequest } from "../component/shared/MainStyles";

export const StatusSpan = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: ${(props: { color?: string | number }) => props?.color};
  padding-right: 15px;
`;
export const QuoteSpan = styled.span`
  color: #39dd84;
  font-weight: bold;
  font-size: 12px;
`;
const getRequestEvolution = {
  [ERequestStatus.Requested]: "33%",
  [ERequestStatus.Accepted]: "66%",
  [ERequestStatus.Declined]: "100%",
  [ERequestStatus.Approved]: "100%",
};

export const requestStatusColor = {
  [ERequestStatus.Requested]: "57, 158, 191",
  [ERequestStatus.Accepted]: "249, 148, 72",
  [ERequestStatus.Approved]: "50, 212, 21",
  [ERequestStatus.Declined]: "228, 78, 81",
};
const statusColor = {
  [ERequestStatus.Requested]: "#399ebf",
  [ERequestStatus.Accepted]: "rgb(249, 148, 72)",
  [ERequestStatus.Approved]: "rgb(50,212,21)",
  [ERequestStatus.Declined]: "rgb(228,78,81)",
};

export const useRequestRowColumns = (): Column<Partial<Request>>[] => {
  const { text } = useText();
  const requestServiceMap = {
    [ERequestType.Mad]: "Dedicated Courier",
    [ERequestType.Nt]: "National Transport",
    [ERequestType.Tr]: "Paps Tour",
    [ERequestType.Msg]: "Messagerie",
  };
  const showQuoteAvailable = (status: ERequestStatus, documents: RequestDocument[]) => {
    return (
      status === ERequestStatus.Requested && documents.length > 0 && <QuoteSpan>{text.all.quote_available}</QuoteSpan>
    );
  };

  return [
    {
      field: "uid",
      title: `${text.all.request_id}`,
    },
    {
      field: "type",
      title: "Services",
      render: ({ type }) => (
        <p style={{ color: requestColorPrinter({ requestType: type }) }}>{requestServiceMap[type]}</p>
      ),
    },
    {
      field: "client",
      title: "Clients",
      render: ({ client }) => client.client_company_name,
    },
    {
      field: "createdAt",
      title: `${text.all.creation_date}`,
      render: ({ createdAt }) => moment(createdAt).format(DATE_FORMAT_PRINT),
    },
    {
      field: "startDate",
      title: `${text.all.execution_date}`,
      render: ({ startDate }) => moment(startDate).format(DATE_FORMAT_PRINT),
    },
    {
      field: "status",
      title: `${text.all.status}`,
      render: ({ status, documents, type, handler, dispatcher }) => (
        <StatusContainerRequest>
          <div>
            <StatusSpan style={{ color: statusColor[status] }}>{status}</StatusSpan>
            {showQuoteAvailable(status, documents)}
          </div>
          <LinearEvulotionRequest>
            <Evolution style={{ width: getRequestEvolution[status] }} background-color={requestStatusColor[status]} />
          </LinearEvulotionRequest>
        </StatusContainerRequest>
      ),
    },
  ];
};
